import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql, navigate } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import RecommenderSection from "../../molecules/recommender-section/recommenderSection";
import RecommendedAuthor from "../../molecules/recommended-author/recommendedAuthor";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./recommenderPage.scss";
import { parsearDescripcionRaw } from "../../../utils/parsearDescripcionRaw";

const RecommenderPage = (props: ReferenciaContenido) => {
  const data = useStaticQuery(graphql`
    query QueryPageRecommender {
      allContentfulHome(filter: { titulo: { eq: "Home bibliotecas" } }) {
        nodes {
          referenciaContenido {
            tipoComponente
            textoRecomendador
            tituloBoton
            botonOmitir
            redireccionBoton
            referenciaPlantillaContenido {
              imagenPrincipal {
                file {
                  url
                }
              }
              tipoTitulo
              tituloBanner
            }
            tituloGeneral
            descripcion {
              raw
            }
          }
        }
      }
    }
  `);

  const [progressPercent, setProgressPercent] = useState(25);
  const [currentStep, setCurrentStep] = useState(0);
  const [selections, setSelections] = useState([-1, -1, -1, -1]);
  const [nextBtnEnable, setNextBtnEnable] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const { isBrowser, document, window } = useBrowserMode();

  useEffect(() => {
    setNextBtnEnable(selections[currentStep] !== -1);
    document.querySelector("body")?.classList.remove("freeze-page");
  }, [selections, currentStep]);

  useEffect(() => {
    isBrowser && document.addEventListener("scroll", onScrollAction);
    return () => {
      isBrowser && document.removeEventListener("scroll", onScrollAction);
    };
  }, []);

  let stepsData = parsearDescripcionRaw(data.allContentfulHome.nodes[0].referenciaContenido.filter(
    (el) => el.tipoComponente === "Recomendador"
  ));
  stepsData[0].referenciaPlantillaContenido =
    props.referenciaPlantillaContenido;

  const handleSelections = (selection) => {
    let auxSelections = [...selections];
    selections[currentStep] !== selection
      ? (auxSelections[currentStep] = selection)
      : (auxSelections[currentStep] = -1);
    setSelections(auxSelections);
  };

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
    setProgressPercent((100 / selections.length) * (currentStep + 2));
  };

  const skipStep = () => {
    nextStep();
    let auxSelections = [...selections];
    auxSelections[currentStep] = -1;
    setSelections(auxSelections);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
    setProgressPercent((100 / selections.length) * currentStep);
  };

  const checkForSelection = () => selections.some((sel) => sel !== -1);

  const makeSearch = async () => {
    let materias: Array<any> = [[], []];
    let series: Array<any> = [];
    let emocion =
      selections[0] !== -1
        ? stepsData[0].referenciaPlantillaContenido[selections[0]].tipoTitulo ||
          false
        : "";
    let autor: any = selections[3] !== -1 ? selections[3] : "";
    for (let i = 1; i <= 2; i++) {
      if (selections[i] !== -1) {
        const materias_series =
          stepsData[i].referenciaPlantillaContenido[selections[i]].tipoTitulo ||
          "";
        if (materias_series.indexOf("/") !== -1) {
          let auxArray = materias_series.split("/");
          materias[i - 1] = auxArray[0].split(",");
          series = auxArray[1] ? series.concat(auxArray[1].split(",")) : series;
        } else if (materias_series !== "") {
          materias[i - 1] = materias_series.split(",");
        } else {
          materias[i - 1] = [];
          series.push(true);
        }
      } else {
        materias[i - 1] = [];
      }
    }
    const words = {
      emotion:
        selections[0] !== -1
          ? stepsData[0].referenciaPlantillaContenido[selections[0]]
              .tituloBanner
          : "",
      format:
        selections[1] !== -1
          ? stepsData[1].referenciaPlantillaContenido[selections[1]]
              .tituloBanner
          : "",
      thematic:
        selections[2] !== -1
          ? stepsData[2].referenciaPlantillaContenido[selections[2]]
              .tituloBanner
          : "",
      author: selections[3] !== -1 ? selections[3] : "",
    };
    navigate("/resultados-recomendador/", {
      state: { emocion, materias, series, autor, words },
    });
    if (window.location.href.indexOf("resultados-recomendador") !== -1)
      location.reload();
  };

  const getNameForGtm = (index: number) => {
    switch (index) {
      case 0:
        return "Emocion";
      case 1:
        return "Formato";
      case 2:
        return "Tematica";
      case 3:
        return "Autor";
    }
  };

  let timerScroll: any;
  const onScrollAction = () => {
    window.clearTimeout(timerScroll);
    timerScroll = setTimeout(() => {
      const headerElement = document.getElementsByClassName(
        "m-header__hide-desktop"
      );
      headerElement[0] ? setHideHeader(true) : setHideHeader(false);
    }, 66);
  };

  return (
    <div className="o-recommender-page__container">
      <div
        className={`o-recommender-page__container__progress ${
          hideHeader ? "o-recommender-page__container__progress--top" : ""
        }`}
      >
        <span style={{ width: `${progressPercent}%` }}></span>
      </div>
      <div className="o-recommender-page__container__header">
        <button
          className={`icon-arrow-left ${currentStep === 0 ? "hide" : ""}`}
          onClick={() => prevStep()}
        />
      </div>
      {currentStep < 3 ? (
        <RecommenderSection
          title={stepsData[currentStep].tituloGeneral}
          subtitle={
            stepsData[currentStep].descripcion.json.content[0].content[0].value
          }
          cardsInfo={stepsData[currentStep].referenciaPlantillaContenido}
          skipBtnText={stepsData[currentStep].botonOmitir}
          nextBtnText={stepsData[currentStep].tituloBoton}
          finishText={stepsData[currentStep].textoRecomendador}
          selected={selections[currentStep]}
          handleSelections={handleSelections}
          nextBtnEnable={nextBtnEnable}
          nextBtnFunction={nextStep}
          skipBtnFunction={skipStep}
          finishFunction={makeSearch}
          finishEnable={checkForSelection()}
          gtmName={getNameForGtm(currentStep)}
          shuffleText={stepsData[currentStep].redireccionBoton || ""}
        />
      ) : (
        <RecommendedAuthor
          title={stepsData[currentStep].tituloGeneral}
          subtitle={
            stepsData[currentStep].descripcion.json.content[0].content[0].value
          }
          cardsInfo={stepsData[currentStep].referenciaPlantillaContenido}
          skipBtnText={stepsData[currentStep].botonOmitir}
          nextBtnText={stepsData[currentStep].tituloBoton}
          finishText={stepsData[currentStep].textoRecomendador}
          selected={selections[currentStep]}
          handleSelections={handleSelections}
          nextBtnEnable={nextBtnEnable}
          nextBtnFunction={nextStep}
          skipBtnFunction={skipStep}
          finishFunction={makeSearch}
          finishEnable={checkForSelection()}
        />
      )}
    </div>
  );
};

export default RecommenderPage;
